import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import AuthContext, { isTokenExpired } from '../../contexts/authContext';
import asides from '../../routes/asideRoutes';

const AsideRoutes = () => {
	const { authData } = useContext(AuthContext);
	const isLoggedIn =
		!!authData?.token?.accessToken && !isTokenExpired(authData?.token?.accessTokenExpiry);

	if (!isLoggedIn) {
		return null;
	}

	return (
		<Routes>
			{asides.map((page) => (
				// eslint-disable-next-line react/jsx-props-no-spreading
				<Route key={page.path} {...page} />
			))}
		</Routes>
	);
};

export default AsideRoutes;
